	export enum AppointmentStatusEnum {
		Scheduled = 1,
		CheckedIn = 2,
		CheckedOut = 3,
		Canceled = 4,
		NoShow = 5,
		Confirmed = 6
	}
